import React, { Component } from 'react';
import { ActivityMonitorConstants } from './services/ActivityMonitorConsts';
import './ActivityMonitor.scss';
import auth from "../../services/auth/AuthProvider";
import CardWidgetInactivity from '../card-widget/CardWidgetInactivity'
import CardWidgetContent from '../card-widget/CardWidgetContent'
import { withRouter } from 'react-router-dom'

class ActivityMonitorContent extends Component {
    constructor(props) {
        super(props);

        this.startTime = null;
        this.countdownTimer = null;

        this.state = {
            started: props.started,
            timeRemaining: ''
        };
        if (props.started) {
            this.startCountdownTimer();
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.started !== newProps.started) {
            this.setState({ started: newProps.started })
            if (newProps.started) {
                this.startCountdownTimer();
            }
        }
    }

    handleLogout = (isAuto) => {
        if (isAuto === true) {
            window.sessionStorage.setItem('myblock.logouttype', 'auto')
        }
        this.stopCountdownTimer();
        auth.logout();
    }

    staySignedIn = () => {
        this.stopCountdownTimer();
        if (this.props.onStaySignedIn) {
            this.props.onStaySignedIn();
        }
    }

    stopCountdownTimer = () => {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer)
            this.countdownTimer = null
        }
        this.startTime = null;
    }

    startCountdownTimer = () => {
        this.startTime = new Date().getTime();
        this.countdownTimer = setInterval(() => {
            var startTime = this.startTime || new Date().getTime()
            var msRemaining = ActivityMonitorConstants.ACTIVITY_TIME_TO_LOGOUT_SECONDS * 1000 - (new Date().getTime() - startTime);
            if (msRemaining < 1000) {
                this.handleLogout(true);
            } else {
                var min = Math.floor(msRemaining / (1000 * 60));
                var s = Math.floor((msRemaining / 1000) - min * 60);
                if (s < 10) {
                    s = '0' + s;
                }

                this.setState({ timeRemaining: min > 0 ? ('' + min + ':' + s) : ('0:' + s) })
            }
        }, ActivityMonitorConstants.COUNTDOWN_INTERVAL_MS);
    }

    getCountdownCardContent = () => {
        return <CardWidgetContent contentText="inactivity_timeout.description" className="logout-card-widget-top-margin" />;
    };

    getCardSubtitle = () => {
        return <CardWidgetContent contentText="inactivity_timeout.subtitle" className="logout-card-widget-top-margin" />;
    }

    render() {
        return (
            <CardWidgetInactivity getCardSubtitle={this.getCardSubtitle}
                getCardContent={this.getCountdownCardContent}
                submitButtonAction={this.staySignedIn}
                submitButtonText="inactivity_timeout.signed_in_button_label"
                submitButtonParams={{ remainingTime: this.state.timeRemaining }}
            />
        )
    };
}

export default withRouter(ActivityMonitorContent);